import React from "react";
import { ProgressSpinner } from "primereact/progressspinner";

const ProgressSpinnerComponent = () => <ProgressSpinner style={{ width: "50px", height: "50px" }} strokeWidth="8" fill="var(--surface-ground)" animationDuration=".5s" />;

export default ProgressSpinnerComponent;
